export function valueFormatter(value: number | string): string | number {
    const inputValue = Number(value);
    if (inputValue >= 1000000) {
        return (inputValue / 1000000).toFixed(1) + "M"; // Show in M format for millions
    } else if (inputValue >= 1000) {
        return (inputValue / 1000).toFixed(1) + "k"; // Show in k format for thousands
    }
    return inputValue; // Show value as-is for values below 1000
}
